import * as React from "react"
import { Box, Chip, Tooltip, Typography } from "@mui/material"

import { MODE_BY_SETUP, PRICE_COLUMN_BY_MODE, RRSP_DISABLED } from "../@constants"
import { customerSetup } from "../@signals"


/** What the customer is today, next to the selector that can change it.
 *
 * Shows the role breakdown because it is rarely unanimous: 12 of 24 customers hold both roles,
 * normally as a dominant one plus a straggler or two (customer 6 is 167 `user` + 1 `retailerUser`).
 * The mode shown is the dominant one, and the `mixed` chip is the warning that it is not the whole
 * story — otherwise flipping the mode would silently ignore those users.
 */
export default function ManagementPricingConfigSetupSummary() {

    const setup = customerSetup.value
    if (!setup) return <></>

    const currentMode = MODE_BY_SETUP[setup.mode]
    const roles = setup.roles?.map(({ role, users }) => `${role}: ${users}`).join(' · ')

    return <Box display="flex" alignItems="center" flexWrap="wrap" gap={1}>
        <Typography variant="body2" color="text.secondary">
            Today:
        </Typography>

        <Tooltip title={roles || 'No enabled users'}>
            <Chip
                size="small"
                color={currentMode ? 'default' : 'warning'}
                label={currentMode
                    ? `${PRICE_COLUMN_BY_MODE[currentMode]} · ${setup.totalUsers} users`
                    : 'No enabled user to infer the type from'}
            />
        </Tooltip>

        {!!setup.mixed && <Tooltip title="Both roles coexist; the mode shown is the dominant one">
            <Chip size="small" color="warning" variant="outlined" label={
                `mixed: ${setup.retailerUsers} retailerUser / ${setup.standardUsers} user`
            } />
        </Tooltip>}

        <Chip
            size="small"
            variant="outlined"
            label={`${setup.mainSites} main site${setup.mainSites === 1 ? '' : 's'} configured`}
        />

        {setup.useRrsp === RRSP_DISABLED && <Tooltip
            title="DIPI_CUSTOMER_FEATURES.use_rrsp = 0 — the app drops its RRSP columns"
        >
            <Chip size="small" color="warning" variant="outlined" label="RRSP feature off" />
        </Tooltip>}
    </Box>
}
